/**
 * @generated SignedSource<<d4dbd2cd95196167d91f939ea5fbd983>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RestoreData_viewer$data = {
  readonly id: string;
  readonly missionControlData: {
    readonly id: string;
    readonly paginatedDeletedTaskList: {
      readonly id: string;
      readonly pageSize: number | null;
      readonly pageNumber: number | null;
      readonly totalObjectCount: number | null;
      readonly pageContents: ReadonlyArray<{
        readonly id: string;
        readonly name: string | null;
        readonly projectName: string | null;
        readonly deletedAt: string | null;
        readonly deletedBy: string | null;
      } | null> | null;
    } | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"MissionControlHeader_viewer">;
  readonly " $fragmentType": "RestoreData_viewer";
};
export type RestoreData_viewer$key = {
  readonly " $data"?: RestoreData_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"RestoreData_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "companyId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "daysAgo"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "page"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "RestoreData_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MissionControlHeader_viewer"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MissionControlDataType",
      "kind": "LinkedField",
      "name": "missionControlData",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "companyId",
              "variableName": "companyId"
            },
            {
              "kind": "Variable",
              "name": "daysAgo",
              "variableName": "daysAgo"
            },
            {
              "kind": "Variable",
              "name": "page",
              "variableName": "page"
            }
          ],
          "concreteType": "MissionControlPaginatedDeletedTasksType",
          "kind": "LinkedField",
          "name": "paginatedDeletedTaskList",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "pageSize",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "pageNumber",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalObjectCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "MissionControlDeletedTaskType",
              "kind": "LinkedField",
              "name": "pageContents",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "projectName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "deletedAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "deletedBy",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "06c612c5dd10505773023b1c4f9dbf56";

export default node;
